import React, { ReactNode, createContext, useState } from "react";

type MaintenanceCtxType = {
  shouldReEvaluate: boolean;
  updateStatus: (bool: boolean) => void;
};

export const MaintenanceCtx = createContext<MaintenanceCtxType>({
  shouldReEvaluate: false,
  updateStatus: (bool) => bool,
});

export const MaintenanceCtxProvider: React.FC<ReactNode> = ({ children }) => {
  const [shouldReEvaluate, setShouldReEvaluate] = useState<boolean>(false);

  const updateStatus = (bool: boolean) => setShouldReEvaluate(bool);

  return (
    <MaintenanceCtx.Provider value={{ shouldReEvaluate, updateStatus }}>
      {children}
    </MaintenanceCtx.Provider>
  );
};
